/*
 * Menu
 */
(function() {
    let availableMenus = document.querySelectorAll('[data-module="dropdown-menu"]');

    let triggerBtn = document.querySelectorAll('button.ariamenu');

    for (var g = triggerBtn.length - 1; g >= 0; g--) {
        triggerBtn[g].addEventListener("click", function( e ){
             e.preventDefault();

            let btn = this;
            let svg = btn.querySelector('svg');

            let list = this.parentNode.querySelector('ul');
            let listItems = list.children;

            let hiddenInput = this.parentNode.querySelector('input');

            btn.classList.toggle('ariamenu-open');
            svg.classList.toggle('rotate-180');

            list.toggleAttribute('hidden');

            if(btn.classList.contains('ariamenu-open')){
                btn.ariaExpanded = true;
            }
            else{
                btn.ariaExpanded = false;
            }

            console.log(btn.classList.contains('ariamenu-open'), btn.ariaExpanded);

            for (var i = listItems.length - 1; i >= 0; i--) {
                let checkbox = listItems[i].querySelector('button');

                checkbox.addEventListener("click", function( e ){
                    e.preventDefault();

                    let t = this;
                    let svg = t.querySelector('.checkbox > svg');
                    let isChecked = t.getAttribute('aria-checked');
                    let onlyOneAllowed = t.dataset.onlyOne;

                    if(!isChecked) isChecked = false;
                    if(!onlyOneAllowed) onlyOneAllowed = false;


                    if(isChecked == "true"){
                        t.setAttribute('aria-checked', false);
                        svg.classList.add('hidden');

                        let val = (t.dataset.termId !== 'null') ? t.dataset.termId : t.dataset.year;

                        removeIdValue( hiddenInput, val );
                        updateCount(t.parentNode.parentNode.parentNode.querySelector('button.ariamenu'), hiddenInput);
                    }
                    else{
                        // console.log('Click', isChecked, onlyOneAllowed);

                        let val = (t.dataset.termId !== 'null') ? t.dataset.termId : t.dataset.year;

                        if(onlyOneAllowed){
                            // Unchedk other boxes and reset values
                            let otherCheckBoxes = document.querySelectorAll('[data-only-one]');
                            for (var i = otherCheckBoxes.length - 1; i >= 0; i--) {
                                otherCheckBoxes[i].setAttribute('aria-checked', false);
                                let loopSVG = otherCheckBoxes[i].querySelector('.checkbox > svg');
                                loopSVG.classList.add('hidden');
                            };
                            hiddenInput.value = "";

                            // Set current checkbox and value
                            t.setAttribute('aria-checked', true);
                            svg.classList.remove('hidden');

                            addIdValue( hiddenInput, val );

                            // console.log('Only One: ', val, hiddenInput);
                        }
                        else{
                            t.setAttribute('aria-checked', true);
                            svg.classList.remove('hidden');

                            // console.log(t.dataset);

                            addIdValue( hiddenInput, val );
                            updateCount(t.parentNode.parentNode.parentNode.querySelector('button.ariamenu'), hiddenInput);
                        }

                    }
                });
            }

            // List is now hidden, remove tabindex
            if(list.hasAttribute('hidden')){
                for (var i = listItems.length - 1; i >= 0; i--) {
                    listItems[i].querySelector('button').toggleAttribute('tabindex', -1);
                };
            }
            // List is now visubke, enable tabindex
            else{
                for (var i = listItems.length - 1; i >= 0; i--) {
                    listItems[i].querySelector('button').toggleAttribute('tabindex', 0);
                };
            }
        });
    }

    function updateCount(btn, input){
        let inputValueToArray = input.value.split(',');
        inputValueToArray = inputValueToArray.filter(function(entry) { return entry.trim() != ''; });

        // console.log('updateCount: ', btn.querySelector('.selected-count').textContent, inputValueToArray);

        btn.querySelector('.selected-count').textContent = inputValueToArray.length;
    }

    function addIdValue(input, value){
        // console.log('Add: ', input, value);

        let currentValue = input.value;
        let newValue;

        if(currentValue.length  == 0){
            newValue = [ value ];
        }
        else{
            let tmpNewValue = currentValue+','+value;
            let tmpArray = tmpNewValue.split(','); // array

            // Clean array of possible duplicates
            tmpArray = tmpArray.filter(function (val, index) {
                return tmpArray.indexOf(val) === index;
            });

            newValue = tmpArray;
        }

        input.value = newValue.toString();
    }

    function removeIdValue(input, value){
        // console.log('Remove: ', input, value);

        let currentValue = input.value;

        if(currentValue.length > 0){
            let tmpArray = currentValue.split(',');
            let arrayIndex = tmpArray.indexOf( value );

            // Remove selected value from temp array.
            if (arrayIndex > -1) {
                tmpArray.splice(arrayIndex, 1);
            }

            // Clean array of possible duplicates
            tmpArray = tmpArray.filter(function (val, index) {
                return tmpArray.indexOf(val) === index;
            });

            input.value = tmpArray.toString();
        }
        else{
            input.value = "";
        }

    }

})();